
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.3","height":"27.892"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Gruppe 172"}},[_c('g',{attrs:{"data-name":"Gruppe 171","transform":"translate(.263 .65)","stroke":"#fff","stroke-width":"1.3"}},[_c('rect',{attrs:{"data-name":"Rechteck 78","width":"20","height":"24","rx":"2","transform":"translate(.387 2.592)","fill":"none","stroke-linejoin":"round"}}),_c('path',{attrs:{"data-name":"Pfad 122","d":"M14.578 2.243v1.682a1.682 1.682 0 01-1.682 1.682H7.289a1.682 1.682 0 01-1.682-1.682V2.243","fill":"none","stroke-miterlimit":"10"}}),_c('path',{attrs:{"data-name":"Pfad 123","d":"M7.849 2.243a2.243 2.243 0 014.485 0","fill":"none","stroke-miterlimit":"10"}}),_c('path',{attrs:{"data-name":"Linie 17","fill":"none","stroke-miterlimit":"10","d":"M2.387 9.592h9"}}),_c('path',{attrs:{"data-name":"Pfad 124","d":"M13.456 10.092l1.121 1.121 2.243-2.242","fill":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"data-name":"Linie 18","fill":"none","stroke-miterlimit":"10","d":"M2.387 15.592h9"}}),_c('path',{attrs:{"data-name":"Pfad 125","d":"M13.456 15.698l1.121 1.121 2.243-2.242","fill":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"data-name":"Linie 19","fill":"none","stroke-miterlimit":"10","d":"M2.387 21.592h9"}}),_c('path',{attrs:{"data-name":"Pfad 126","d":"M13.456 21.305l1.121 1.121 2.243-2.242","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])])])
          )
        }
      }
    